import React from "react"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import LoginNew from "../pages/Authentication/Login/Login"
import LoginPvs from "pages/Authentication/Login/LoginPvs"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"

// Dashboard Events
import UpcomingEvents from "../pages/Admin/Events/UpcomingList"
import PastEvents from "../pages/Admin/Events/PastList"
import CategoryList from "../pages/Admin/Events/CategoryList"
import AddEvent from "../pages/Admin/Events/AddEvent"
// import AwardsList from "../pages/Admin/AwardsList"
import Dashboard from "../pages/Admin/index"
import EventView from "../pages/Admin/Events/EventView"
import EditEvent from "../pages/Admin/Events/EditEvent"
import LuckyDrawUserList from "../pages/Admin/LuckyDrawUserList"

//Frontend
import Frontend from "../pages/index"
import BookEvent from "../pages/Users/Events/BookEvent"
import EventsDetail from "../pages/Users/Events/EventsDetail"
import Awards from "../pages/Users/Forms/Awards"
import Congratulations from "../pages/Users/Forms/Congratulations"
import LuckyDrawForm from "pages/Users/Forms/pbl-21122024"
import AddCategory from "pages/Admin/Events/AddCategory"
import EditCategory from "pages/Admin/Events/EditCategory"
import UserList from "pages/Admin/Users/UserList"
import ViewUser from "pages/Admin/Users/ViewUser"
import PvsList from "pages/Admin/Pvs/PvsList"
import PvsPendingList from "pages/Admin/Pvs/PvsPendingList"
import PvsPaidList from "pages/Admin/Pvs/PvsPaidList"
import PvsRejectedList from "pages/Admin/Pvs/PvsRejectedList"
import EditPvs from "pages/Admin/Pvs/EditPvs"
import PvsKeywords from "pages/Admin/Pvs/PvsKeywords"
import PvsCategory from "pages/Admin/Pvs/PvsCategory"
import PvsSubCategory from "pages/Admin/Pvs/PvsSubCategory"
import PvsBrand from "pages/Admin/Pvs/PvsBrand"
import AddPvsCategory from "pages/Admin/Pvs/AddPvsCategory"
import AddPvsSubcategory from "pages/Admin/Pvs/AddPvsSubcategory"
import AddPvsKeyword from "pages/Admin/Pvs/AddPvsKeyword"
import EditPvsKeyword from "pages/Admin/Pvs/EditPvsKeyword"
import EditPvsCategory from "pages/Admin/Pvs/EditPvsCategory"
import EditPvsSubcategory from "pages/Admin/Pvs/EditPvsSubcategory"
import AllBazaarList from "pages/Admin/Bazaar/AllBazaarList"
import ViewBookingList from "pages/Admin/Bazaar/ViewBookingList"
import AddBazaar from "pages/Admin/Bazaar/AddBazaar"
import EditBazaar from "pages/Admin/Bazaar/EditBazaar"
import BazaarRegistration from "pages/Admin/Bazaar/BazaarRegistration"
import BazaarPayment from "pages/Admin/Bazaar/BazaarPayment"
import ViewSlotsList from "pages/Admin/Bazaar/ViewSlotsList"
import EditSlots from "pages/Admin/Bazaar/EditSlots"
import RegenerateInvoice from "pages/Admin/Bazaar/RegenerateInvoice"
import UserDashboard from "pages/Users/UserDashboard"
import PVSRegistration from "pages/Users/PVSRegistration"
import ConfirmRegistration from "pages/Users/PVSRegistration/ConfirmRegistration"
import Checkout from "pages/Users/PVSRegistration/Checkout"
import PVSPaymentSuccess from "pages/Users/PVSRegistration/PVSPaymentSuccess"
import AwardsNew from "pages/Users/Forms/AwardsNew"
import UserBazaarInfo from "pages/Users/UserBazaarInfo"
import Home from "pages/Users/Home"
import Unauthorized from "pages/Unauthorized"
import AwardsForm from "pages/Users/Awards/AwardsForm"
import AwardBillingDetails from "pages/Users/Awards/AwardBillingDetails"
import NomineeAwardFormTwo from "pages/Users/Awards/NomineeAwardFormTwo"
import NomineeBookingConfirm from "pages/Users/Awards/NomineeBookingConfirm"
import NominationList from "pages/Admin/Awards/NominationList"
import EditNomination from "pages/Admin/Awards/EditNomination"
import AwardsList from "pages/Admin/Awards/AwardsList"
import AddAward from "pages/Admin/Awards/AddAward"
import EditAward from "pages/Admin/Awards/EditAward"
import AwardCategoryList from "pages/Admin/Awards/AwardCategoryList"
import AddAwardCategory from "pages/Admin/Awards/AddAwardCategory"
import EditAwardCategory from "pages/Admin/Awards/EditAwardCategory"
import RazorpayTest from "pages/RazorpayTest"
import UnderDevelopment from "pages/UnderDevelopment"
import AddSlots from "pages/Admin/Bazaar/AddSlots"
import PaymentStatistics from "pages/Admin/Bazaar/PaymentStatistics"
import BookingReport from "pages/Admin/Bazaar/BookingReport"
import BalanceReport from "pages/Admin/Bazaar/BalanceReport"
import PVSInfo from "pages/Users/PVSInfo"
import Profile from "pages/Users/Profile"
import BazaarInfo from "pages/Users/BazaarInfo"
import EventsDetailAuth from "pages/Users/Events/EventsDetailAuth"
import EventsAuth from "pages/Users/EventsAuth"
import AwardsInfo from "pages/Users/AwardsInfo"
import PvsClarificationList from "pages/Admin/Pvs/PvsClarificationList"
import ViewPvsDetails from "pages/Admin/Pvs/ViewPvsDetails"
import ProductList from "pages/Admin/Pvs/ProductList"
import AddProduct from "pages/Admin/Pvs/AddProduct"
import EditProduct from "pages/Admin/Pvs/EditProduct"
import BazaarInterestForm from "pages/Users/Forms/BazaarInterestForm"
import BazaarInterestList from "pages/Admin/Bazaar/BazaarInterestList"
import AllInvoices from "pages/Admin/Invoices/AllInvoices"
// TEMPORARY: remove with pages/Admin/DbChecks
import DbChecks from "pages/Admin/DbChecks"
import SystemUsers from "pages/Admin/Users/SystemUsers"
import BazaarEnquiryList from "pages/Admin/Bazaar/BazaarEnquiryList"
import VolunteerBazaarList from "pages/Volunteer/BazaarList"
import BazaarEnquiryForm from "pages/Volunteer/BazaarEnquiryForm"

//Frontend routes without auth token
const frontendRoutes = [
  { path: "/", component: <Frontend /> },

  { path: "/event-details/:url", component: <EventsDetail /> },
  { path: "/awards", component: <Awards /> },
  { path: "/awards-new", component: <AwardsNew /> },
  { path: "/ld/pbl-34-04052025", component: <LuckyDrawForm /> },
  { path: "/razorpay-test", component: <RazorpayTest /> },
  { path: "/unauthorized", component: <Unauthorized /> },
]

const adminRoutes = [
  { path: "/dashboard", component: <Dashboard /> },

  // Awards
  { path: "/awards-list", component: <AwardsList /> },
  { path: "/awards/nominations", component: <NominationList /> },
  { path: "/awards/nomination-details", component: <EditNomination /> },
  { path: "/awards/add-award", component: <AddAward /> },
  { path: "/awards/edit-award", component: <EditAward /> },
  { path: "/awards/categories/:enc_award_id", component: <AwardCategoryList /> },
  { path: "/awards/add-award-category", component: <AddAwardCategory /> },
  { path: "/awards/edit-award-category", component: <EditAwardCategory /> },

  // Events
  { path: "/events/upcoming-list", component: <UpcomingEvents /> },
  { path: "/events/past-list", component: <PastEvents /> },
  { path: "/events/category-list", component: <CategoryList /> },
  { path: "/events/add-category", component: <AddCategory /> },
  { path: "/events/edit-category/:url", component: <EditCategory /> },
  { path: "/events/add-event", component: <AddEvent /> },
  { path: "/events/edit-event/:url", component: <EditEvent /> },
  { path: "/events/view-event/:url", component: <EventView /> },

  // Users
  { path: "/users", component: <UserList /> },
  { path: "/view-user/:type/:enc_id", component: <ViewUser /> },
  { path: "/lucky-draw-user", component: <LuckyDrawUserList /> },
  { path: "/system-users", component: <SystemUsers /> },

  // PVS
  { path: "/pvs", component: <PvsList /> },
  { path: "/paid-pvs", component: <PvsPaidList /> },
  { path: "/pvs-clarification", component: <PvsClarificationList /> },
  { path: "/pending-pvs", component: <PvsPendingList /> },
  { path: "/rejected-pvs", component: <PvsRejectedList /> },
  { path: "/edit-pvs/:enc_pvs_entry_id", component: <EditPvs /> },
  { path: "/pvs-details/:enc_pvs_entry_id", component: <ViewPvsDetails /> },
  { path: "/pvs-keywords", component: <PvsKeywords /> },
  { path: "/pvs-category", component: <PvsCategory /> },
  { path: "/pvs-subcategory", component: <PvsSubCategory /> },
  { path: "/pvs-brand", component: <PvsBrand /> },
  { path: "/add-pvs-category", component: <AddPvsCategory /> },
  { path: "/add-pvs-subcategory", component: <AddPvsSubcategory /> },
  { path: "/edit-pvs-keyword/:enc_pvs_key_id", component: <EditPvsKeyword /> },
  { path: "/add-pvs-keyword", component: <AddPvsKeyword /> },
  {
    path: "/edit-pvs-category/:enc_pvs_cat_id",
    component: <EditPvsCategory />,
  },
  {
    path: "/edit-pvs-subcategory/:enc_pvs_subcat_id",
    component: <EditPvsSubcategory />,
  },
  
  // Products
  { path: "/product-list", component: <ProductList /> },
  { path: "/add-product", component: <AddProduct /> },
  { path: "/edit-product", component: <EditProduct /> },
  
  // PULA Bazaar
  { path: "/all-bazaar-list", component: <AllBazaarList /> },
  { path: "/slots-list", component: <ViewSlotsList /> },
  { path: "/add-slots", component: <AddSlots /> },
  { path: "/edit-slots", component: <EditSlots /> },
  { path: "/view-booking-list", component: <ViewBookingList /> },
  { path: "/add-bazaar", component: <AddBazaar /> },
  { path: "/edit-bazaar", component: <EditBazaar /> },
  { path: "/bazaar-registration", component: <BazaarRegistration /> },
  { path: "/add-bazaar-payment", component: <BazaarPayment /> },
  { path: "/invoice-action/:type", component: <RegenerateInvoice /> },
  { path: "/payment-statistics", component: <PaymentStatistics /> },
  { path: "/booking-report", component: <BookingReport /> },
  { path: "/balance-report", component: <BalanceReport /> },
  { path: "/all-invoices", component: <AllInvoices /> },
  { path: "/db-checks", component: <DbChecks /> }, // TEMPORARY
  { path: "/bazaar-interest-list", component: <BazaarInterestList /> },
  { path: "/bazaar-enquiry-list", component: <BazaarEnquiryList /> },
  {
    path: "/bazaar-walk-in",
    component: <VolunteerBazaarList enquiryFormPath="/bazaar-walk-in-form" />,
  },
  {
    path: "/bazaar-walk-in-form",
    component: <BazaarEnquiryForm backPath="/bazaar-walk-in" />,
  },
]

const userRoutes = [
  // Dashboard
  { path: "/home", component: <UserDashboard /> },
  // { path: "/home", component: <Home /> },

  // Profile
  { path: "/user-profile", component: <Profile /> },

  // PVS Registraion
  { path: "/pvs-info", component: <PVSInfo /> },
  { path: "/pvs-registration", component: <PVSRegistration /> },
  { path: "/confirm-registration", component: <ConfirmRegistration /> },
  { path: "/checkout", component: <Checkout /> },
  { path: "/pvs-payment-success", component: <PVSPaymentSuccess /> },

  // Bazaar
  { path: "/bazaar-info", component: <BazaarInfo /> },
  { path: "/bazaar-interest-form", component: <BazaarInterestForm /> },
  { path: "/bazaar-user-info", component: <UserBazaarInfo /> },

  // Awards
  { path: "/awards-info", component: <AwardsInfo /> },
  { path: "/awards-billing-details", component: <AwardBillingDetails /> },
  { path: "/awards/:url", component: <AwardsForm /> },
  { path: "/shortlisted-nominee-form", component: <NomineeAwardFormTwo /> },
  {
    path: "/nominee-booking-confirm",
    component: <NomineeBookingConfirm />,
  },

  // Events
  { path: "/book/:url", component: <BookEvent /> },
  { path: "/events-info", component: <EventsAuth /> },
  { path: "/event/:url", component: <EventsDetailAuth /> },
  { path: "/congratulations", component: <Congratulations /> },
]

const authRoutes = [
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <LoginNew /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/register", component: <Register /> },
]

const volunteerRoutes = [
  { path: "/volunteer/bazaars", component: <VolunteerBazaarList /> },
  { path: "/volunteer/bazaar-enquiry", component: <BazaarEnquiryForm /> },
]

export { frontendRoutes, userRoutes, authRoutes, adminRoutes, volunteerRoutes }
